{
  "publicOrganizationSelectDialog": {
    "title": "Choisir une organisation",
    "subTitle": "Ce compte fait partie de plusieurs organisations. Veuillez en sélectionner une pour continuer."
  },
  "signUpNotAllowedDialog": {
    "title": "Impossible de créer le compte",
    "body": "Avant de pouvoir créer un compte avec nous, nous vous demandons de parler d'abord avec votre conseiller. Veuillez contacter votre conseiller pour recevoir les informations et les conseils nécessaires au processus de création de votre compte."
  },
  "linkExpiredDialog": {
    "title": "Impossible de créer le compte",
    "body": "Le lien d'invitation que vous avez utilisé n'est plus actif. Pour des raisons de sécurité, ces liens expirent après un certain temps. Veuillez contacter votre conseiller ou le représentant de votre entreprise pour en obtenir un nouveau et poursuivre la configuration de votre compte."
  },
  "idpLogout": {
    "closeTabMessage": "Déconnexion terminée — vous pouvez fermer cet onglet."
  }
}
